import { Box, Typography } from '@mui/material';
import { BORDER_MAIN } from 'shared';

type ContentTableColumn = {
  key: string;
  label: string;
  width?: string;
};

type ContentTableProps = {
  ariaLabel: string;
  columns: ContentTableColumn[];
  rows: string[][];
};

const tableWrapperSx = {
  overflowX: 'scroll',
};

const tableCellSx = {
  py: 1.75,
  pr: 2,
  verticalAlign: 'top',
};

const tableCellTextSx = {
  overflowWrap: 'anywhere',
  wordBreak: 'break-word',
};

export const ContentTable = ({ ariaLabel, columns, rows }: ContentTableProps) => {
  return (
    <Box sx={tableWrapperSx}>
      <Box
        component="table"
        aria-label={ariaLabel}
        sx={{
          width: '100%',
          borderCollapse: 'collapse',
          tableLayout: 'fixed',
        }}
      >
        <Box component="thead">
          <Box component="tr">
            {columns.map(({ key, label, width }) => (
              <Box key={key} component="th" sx={{ ...tableCellSx, width, textAlign: 'left' }}>
                <Typography variant="h6" className="accent semi-bold">
                  {label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box component="tbody">
          {rows.map((row) => (
            <Box key={`${ariaLabel}-${row.join('-')}`} component="tr" sx={{ borderTop: BORDER_MAIN }}>
              {row.map((value, cellIndex) => (
                <Box key={`${columns[cellIndex]?.key}-${value}`} component="td" sx={tableCellSx}>
                  <Typography variant={cellIndex === 0 ? 'h6' : 'body1'} sx={tableCellTextSx}>
                    {value}
                  </Typography>
                </Box>
              ))}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
